module.exports = __webpack_public_path__ + "img/next.2ab4d26b.svg";